import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Our_Serviceses.css";
import Point_Down_Lottie from "../../animation/point_down_lottie/Point_Down_Lottie";

const Our_Serviceses = () => {
  const Our_Serviceses = [
    {
      image: "/assets/images/services/service_img/1.png",
      title: "Bullock Cart",
    },
    { image: "/assets/images/services/service_img/2.png", title: "Camel Cart" },
    {
      image: "/assets/images/services/service_img/3.png",
      title: "Wedding Carriage",
    },
    {
      image: "/assets/images/services/service_img/4.png",
      title: "Wedding Mare",
    },
    {
      image: "/assets/images/services/service_img/5.png",
      title: "Pedal Cycle",
    },
    { image: "/assets/images/services/service_img/6.png", title: "Labour" },
    {
      image: "/assets/images/services/service_img/7.png",
      title: "Porter (Coolie)",
    },
    { image: "/assets/images/services/service_img/8.png", title: "Hath Lorry" },
    { image: "/assets/images/services/service_img/9.png", title: "Sanedo" },
    {
      image: "/assets/images/services/service_img/10.png",
      title: "Power Rrailer",
    },
    { image: "/assets/images/services/service_img/11.png", title: "Tractor" },
    {
      image: "/assets/images/services/service_img/12.png",
      title: "Tractor Lorry",
    },
    { image: "/assets/images/services/service_img/13.png", title: "Hitachi" },
    { image: "/assets/images/services/service_img/14.png", title: "JCB" },
    { image: "/assets/images/services/service_img/15.png", title: "Metador" },
    {
      image: "/assets/images/services/service_img/16.png",
      title: "Passenger Rikshaw",
    },
    {
      image: "/assets/images/services/service_img/17.png",
      title: "E-Passenger Rikshaw",
    },
    {
      image: "/assets/images/services/service_img/18.png",
      title: "Pedal Rikshaw",
    },
    {
      image: "/assets/images/services/service_img/19.png",
      title: "E-Loading Rikshaw",
    },
    {
      image: "/assets/images/services/service_img/20.png",
      title: "Chakdo Rikshaw",
    },
    {
      image: "/assets/images/services/service_img/21.png",
      title: "Container Truck",
    },
    { image: "/assets/images/services/service_img/22.png", title: "Truck" },
    { image: "/assets/images/services/service_img/23.png", title: "Eicher" },
    {
      image: "/assets/images/services/service_img/24.png",
      title: "Sleeper Bus",
    },
    {
      image: "/assets/images/services/service_img/25.png",
      title: "Luxury Bus",
    },
    { image: "/assets/images/services/service_img/26.png", title: "Mini Bus" },
    {
      image: "/assets/images/services/service_img/27.png",
      title: "Luxury Car",
    },
    {
      image: "/assets/images/services/service_img/28.png",
      title: "Deluxe Car",
    },
    { image: "/assets/images/services/service_img/29.png", title: "Mini Car" },
    { image: "/assets/images/services/service_img/30.png", title: "E - Car" },
    { image: "/assets/images/services/service_img/31.png", title: "Scooter" },
    {
      image: "/assets/images/services/service_img/32.png",
      title: "Bike & E-Bike",
    },
    { image: "/assets/images/services/service_img/33.png", title: "Train" },
    {
      image: "/assets/images/services/service_img/34.png",
      title: "Ro-Ro Ferry",
    },
    {
      image: "/assets/images/services/service_img/35.png",
      title: "Chartered Plane and Helicopter",
    },
  ];

  return (
    <section className="services-section">
      <Container>
        <h2>Our Services</h2>
        <div className="hover-hint">
          <span>
            Watch service videos{" "}
            <div className="lottie_holder">
              <Point_Down_Lottie />
            </div>
          </span>
        </div>

        <Row>

          <Col lg={4} md={4} sm={6} xs={12} className="mb-5">
            <div className="service-card">
              <div className="service_img_holder">

                <iframe
                  className="service-img"
                  src="https://www.youtube.com/embed/Mm_UsMpPdwE"
                  title="PmRoad क्या है? भारत का अपना, पूरी तरह से स्वदेशी एप्लिकेशन..."
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>

              </div>
              <div className="service_title_holder">
                <p className="service-title">Marketing</p>
              </div>
            </div>
          </Col>

          <Col lg={4} md={4} sm={6} xs={12} className="mb-5">
            <div className="service-card">
              <div className="service_img_holder">
                <iframe className="service-img"
                  src="https://www.youtube.com/embed/bk1gh58eRS0"
                  title="PmRoad App: अब यात्रा और डिलीवरी आसान और सस्ती होगी!"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="service_title_holder">
                <p className="service-title">Customer</p>
              </div>
            </div>
          </Col>

          <Col lg={4} md={4} sm={6} xs={12} className="mb-5">
            <div className="service-card">
              <div className="service_img_holder">
                <video className="service-img" controls muted playsInline>
                  <source
                    // src={process.env.PUBLIC_URL + '/assets/images/services/marketing.mp4'}
                    type="video/mp4"
                  />
                </video>
              </div>
              <div className="service_title_holder">
                <p className="service-title">Driver</p>
              </div>
            </div>
          </Col>



          {Our_Serviceses.map((service, index) => (
            <Col lg={4} md={4} sm={6} xs={12} key={index} className="mb-5">
              <div className="service-card">
                <div className="service_img_holder">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-img"
                  />
                  {/* <div className="service-overlay">
                    <ul>
                      <li>Click here to know more</li>
                      <li>
                        <a
                          href="https://youtu.be/ooM_BNCASes?si=sFx0JvE31e5tm_0f"
                          target="_blank"
                        >
                          {" "}
                          Link 1
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://youtu.be/Fi3_ffeqRqE?si=Mgw17eK5cUg3GhwD"
                          target="_blank"
                        >
                          {" "}
                          Link 2
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://youtu.be/UBYqv21c0Yk?si=OJ8JHx9L9r8NwHqb"
                          target="_blank"
                        >
                          {" "}
                          Link 3
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>
                <div className="service_title_holder">
                  <p className="service-title">{service.title}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Our_Serviceses;
